import { Card } from 'antd';
import { useAppSelector } from '../../../app/hooks';
import { selectTheme, ThemeColor } from '../../../features/theme/themeSlice';

type PersonalDataContainerProps = {
	header?: boolean;
	title?: string | React.ReactChild;
	children?: React.ReactChild | React.ReactChild[];
};

const PersonalDataContainer: React.FC<PersonalDataContainerProps> = ({ children, header = false, title }) => {
	const theme = useAppSelector(selectTheme);

	return (
		<div className={`personal-data-container ${theme.theme == ThemeColor.dark ? 'dark' : ''}`}>
			<div className="personal-data-container-header">
				<label>{title}</label>
			</div>
			<Card style={{ minHeight: '100%' }}>{children}</Card>
		</div>
	);
};

export default PersonalDataContainer;
